(() => {
  const MOBILE_MAX = 749;
  const SWIPE_THRESHOLD = 50;

  if (!window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches) return;

  let startX = 0;
  let startY = 0;
  let endX = 0;
  let endY = 0;
  let isTouching = false;
  let isPinching = false;

  const getOpenModal = () =>
    document.querySelector('.product-media-modal[open]');

  const getItems = (modal) =>
    Array.from(
      modal.querySelectorAll(
        '.product-media-modal__content > *'
      )
    );

  const getActiveIndex = (items) =>
    items.findIndex((item) =>
      item.classList.contains('active')
    );

  const showItem = (items, index) => {
    items.forEach((item) =>
      item.classList.remove('active')
    );

    const newItem = items[index];

    if (!newItem) return;

    newItem.classList.add('active');

    newItem.scrollIntoView({
      behavior: 'instant',
      block: 'center',
      inline: 'center'
    });
  };

  document.addEventListener(
    'touchstart',
    (event) => {
      const modal = getOpenModal();

      if (!modal) return;

      if (event.touches.length > 1) {
        isPinching = true;
        return;
      }

      isPinching = false;
      isTouching = true;

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;

      endX = startX;
      endY = startY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      const modal = getOpenModal();

      if (!modal) return;

      if (event.touches.length > 1) {
        isPinching = true;
        return;
      }

      if (!isTouching) return;

      endX = event.touches[0].clientX;
      endY = event.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    () => {
      const modal = getOpenModal();

      if (!modal || !isTouching || isPinching) {
        isTouching = false;
        isPinching = false;
        return;
      }

      const deltaX = endX - startX;
      const deltaY = endY - startY;

      isTouching = false;

      if (
        Math.abs(deltaX) < SWIPE_THRESHOLD ||
        Math.abs(deltaX) <= Math.abs(deltaY)
      ) {
        return;
      }

      const items = getItems(modal);

      if (!items.length) return;

      let currentIndex = getActiveIndex(items);

      if (currentIndex < 0) currentIndex = 0;

      if (deltaX < 0) {
        currentIndex =
          currentIndex < items.length - 1
            ? currentIndex + 1
            : 0;
      } else {
        currentIndex =
          currentIndex > 0
            ? currentIndex - 1
            : items.length - 1;
      }

      showItem(items, currentIndex);
    },
    { passive: true }
  );
})();